import { render, staticRenderFns } from "./BreadcrumbItem.vue?vue&type=template&id=0f323f8e&scoped=true&"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f323f8e",
  null
  
)

export default component.exports